<script>
import BaseFilterSingle from "./BaseFilterSingle";
import { mapGetters } from "vuex";

export default {
  name: "Actor",
  extends: BaseFilterSingle,
  computed: {
    ...mapGetters({
      options: "users_flattened"
    })
  },
  data() {
    return {
      placeholder: "Uitvoerder",
      filtername: "actor_uuid",
      type: "actor",
      multiple: false // backend can only filter on one actor_uuid
    };
  },
  created: function() {
    this.$store.dispatch("loadUsers");
  }
};
</script>
